import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const digitizationData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/digitization/about'
  },
  {
    label: 'Documentation',
    to: '/pages/digitization/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/digitization/terms'
  },
  {
    label: 'Process',
    to: '/pages/digitization/process'
  },
  {
    label: 'Stats',
    to: '/pages/digitization/stats'
  }
];
